(ns frontend.test.kanban-v2
  (:require
   [frontend.routing :as routing]
   [reagent.core :as r]
   [re-frame.core :as rf]
   [frontend.db :as db]
   [frontend.ux-overhaul.kanban.v2 :as kanban]
   [frontend.ux-overhaul.components.select-with-filter.view :as select-with-filter]))

(def view-settings
  {:sorting        {:sort-by        :id
                    :sort-direction :desc                   ; :asc |:desc
                   }
   :grouping       {}
   :summary-footer {:show-summary? true
                    :content       [:total-count]}
  })

(def card-settings
  {:look-and-feel    {:card-size :large         ; :compact || :medium || :large
                      :show-empty-fields? false ; true || false
                     }
   :color-coding     {:use-color-coding? true
                      :attribute         :owner
                      :operator          :is
                      :matches           {"Tuukka"      "#def5ff"
                                          "Another one" "pink"}}
   :border-highlight {:use-for :rotting-entity}
   :header           {:display-name :name                   ; :name || :alias
                     }

   :card-footer      {:show-footer? true
                      :content-type :icons ; :avatar ||:tags || :icons
                      :content      []     ; Todo
                     }

   :card-body        {:content
                      [{:attribute :tag
                        :ord       1}
                       #_{:attribute :description
                          :ord       2}
                       {:attribute :country
                        :ord       3}
                       {:attribute :target
                        :ord       4}
                       {:attribute :owner
                        :ord       4}]}})


(rf/reg-event-db
 :init-kanban-data
 (fn [db
      [_
       {:keys [column-labels column-contents group-by-attribute
               secondary-group-by-attribute]}]]
   (assoc db
          :group-by-attribute group-by-attribute
          :secondary-group-by-attribute secondary-group-by-attribute
          :initialized? true)))

(rf/reg-event-db
 :init-mock-data
 (fn [db _]
   (let [entities (->> (range 400)
                       (map (fn [i]
                              {:db/id       i
                               :key         i
                               :group       (mod i 8)
                               :header      (str "Task-" i)
                               :owner       (if (= (mod i 2) 0) "Tuukka" "Another one")
                               :target      (condp = (mod i 9)
                                              0 "Company 1"
                                              1 "Company 2"
                                              2 "Company 3"
                                              3 "Company 4"
                                              4 "Corporation 1"
                                              5 "Corporation 2"
                                              6 "LLC 1"
                                              7 "LLC 2"
                                              8 "Big corporation 1")
                               :country     (condp = (mod i 16)
                                              0 "Finland"
                                              1 "Sweden"
                                              2 "Norway"
                                              3 "Denmark"
                                              4 "Estonia"
                                              5 "Germany"
                                              6 "USA"
                                              7 "France"
                                              8 "Spain"
                                              9 "Portugal"
                                              10 "Andorra"
                                              11 "Switzerland"
                                              12 "Austria"
                                              13 "Netherlands"
                                              14 "Brazil"
                                              15 "Australia"
                                              16 "New Zealand")
                               :description (str "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In pulvinar "
                                                 "imperdiet suscipit. Suspendisse non bibendum massa. "
                                                 " Cras bibendum quam tortor, eget rutrum")
                               :tag         (let [tag-number (mod i 30)]
                                              (str "TAG-" tag-number))})))]
     (assoc db :entities entities))))

(rf/reg-event-db
 :on-drag-end
 (fn [db [_ {:keys [item-id source target kanban-data]}]]
   (let [group-by-attribute (:group-by-attribute db)
         column-labels (:column-labels kanban-data)
         entities (:entities db)

         item (->> entities
                   (filter (fn [item]
                             (= (:id item) item-id)))
                   (first))

         new-value (nth column-labels target)

         updated-item (assoc item group-by-attribute new-value)



         new-entities (->> entities
                           (map (fn [entity]
                                  (if (= (:id entity) item-id)
                                    updated-item
                                    entity))))]

     (assoc db :entities new-entities))))

(rf/reg-sub
 :kanban-data
 (fn [db]
   (let [entity-type :entity.type/???                ; This is from the view config?
         group-by-attribute (:group-by-attribute db) ; this is from the view config?
         entities (:entities db)                     ; Entities are from main db

         secondary-group-attr (:secondary-group-by-attribute db)
         ;secondary-group-attr :owner


         grouped-entities (->> entities
                               (group-by group-by-attribute)
                               (into (sorted-map)))
         column-labels (vec (keys grouped-entities))
         column-contents (vec (vals grouped-entities))

         secondary-grouped (->> column-contents
                                (mapv (fn [one-column]
                                        (->> one-column
                                             (group-by secondary-group-attr)
                                             (into (sorted-map))))))

         possible-row-values (->> entities
                                  (mapv (fn [entity]
                                          (get entity secondary-group-attr)))
                                  (into (sorted-set)))

         first-grouping (->> possible-row-values
                             (mapv (fn [group-key]
                                     (->> entities
                                          (filterv (fn [entity]
                                                     (= (get entity secondary-group-attr) group-key)))))))


         possible-column-values (->> entities
                                     (mapv (fn [entity]
                                             (get entity group-by-attribute)))
                                     (into (sorted-set)))

         contents (->> first-grouping
                       (mapv (fn [items]
                               (->> possible-column-values
                                    (mapv (fn [column-value]
                                            (->> items
                                                 (filterv (fn [item]
                                                            (= (get item group-by-attribute) column-value))))))))))

         sec-contents (->> secondary-grouped
                           (mapv vals)
                           (mapv vec))

         sec-labels (->> secondary-grouped
                         (mapv keys)
                         (mapv vec)
                         (first))]
     {:column-labels         column-labels
      :column-contents       column-contents
      :column-groups         sec-labels
      :column-group-contents sec-contents
      :contents              contents})))

(rf/reg-sub
 :group-by-attribute
 (fn [db _]
   (:group-by-attribute db)))

(rf/reg-sub
 :secondary-group-by-attribute
 (fn [db _]
   (:secondary-group-by-attribute db)))

(rf/reg-event-db
 :set-group-by-attribute
 (fn [db [_ {:keys [group-by-attribute]}]]
   (assoc db :group-by-attribute group-by-attribute)))

(rf/reg-event-db
 :set-secondary-group-by-attribute
 (fn [db [_ {:keys [attribute]}]]
   (assoc db :secondary-group-by-attribute attribute)))


(rf/reg-sub
 :initialized?
 (fn [db _]
   (:initialized? db)))

(defn tools
  []
  (let [group-by-attribute (rf/subscribe [:group-by-attribute])
        secondary (rf/subscribe [:secondary-group-by-attribute])
        session-entities @db/entities]
    (fn []
      [:div.d-flex {:style {:padding "20px" :gap 30}}
       [:div
        [:div {:style {:font-size "30px"}} "Columns by "]
        (->> [:target :country :tag :owner]
             (map (fn [kw]
                    (let [test nil]
                      ^{:key (str kw)}
                      [:button
                       {:on-click #(rf/dispatch [:set-group-by-attribute {:group-by-attribute kw}])
                        :style    {:font-size "25px" :text-decoration (when (= @group-by-attribute kw) "underline")}}
                       kw])))
             (doall))]
       [:div
        [:div {:style {:font-size "30px"}} "Grouping by "]
        (->> [:target :country :tag :owner]
             (map (fn [kw]
                    (let [test nil]
                      ^{:key (str kw)}
                      [:button
                       {:on-click #(rf/dispatch [:set-secondary-group-by-attribute {:attribute kw}])
                        :style    {:font-size "25px" :text-decoration (when (= @secondary kw) "underline")}}
                       kw])))
             (doall))]])))

(defmethod routing/render-view :test/kanban-v2
  [{:keys [route-params]}]
  (let [configuration {:view-settings view-settings
                       :card-settings card-settings}

        _ (rf/dispatch [:init-mock-data])


        _ (rf/dispatch [:init-kanban-data
                        {:group-by-attribute :target
                         :secondary-group-by-attribute :country}])

        kanban-data (rf/subscribe [:kanban-data])
        initialized? (rf/subscribe [:initialized?])

        select-state (r/atom {:value nil})]
    (fn []
      [:div {:style {:background "#fafafa" :height "100vh"}}
       #_[:div.p-5
          {:style {:max-width "300px"}}
          [select-with-filter/view {:state select-state}]]
       (if @initialized?
         [:<>
          [tools]
          [kanban/view
           {:kanban-id        :kanban-1                     ; This must be unique to identify different kanban boards in re-frame
            :card-renderer    (fn [args]
                                [:div {:style {:padding "10px 20px 10px 20px"}}
                                 [kanban/kanban-card args (:card-settings configuration)]])
            :column-renderer  (partial kanban/default-column-renderer {:data @kanban-data})
            :column-count     (-> @kanban-data
                                  :column-labels
                                  count)
            :data             @kanban-data
            :background-color "white"
            :board-height     800
            :board-width      (.-innerWidth js/window)
            :column-width     320
            :on-drag-end      (fn [{:keys [item-id source-col-index target-col-index]}]
                                (when (and target-col-index (not= source-col-index target-col-index))
                                  (rf/dispatch [:on-drag-end
                                                {:item-id     item-id
                                                 :source      source-col-index
                                                 :target      target-col-index
                                                 :kanban-data @kanban-data}])))
           }]]
         [:div "NOT initliazed"])])))
